module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Five years later…")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NABELLA")]), _vm._v(",")]), _vm._v(" you’ve been standing at the window all morning. Come sit down. You must be exhausted by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anabella tensed, her eyes so dry and gritty that it hurt to blink. “I can’t sit. Not until Lucio comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It could be a while—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t care,” she interrupted huskily, her gaze never leaving the snowcapped Andes. It’d been cold the past few days but this morning was lovely. It felt almost like Spring. “He’ll come for me. He promised.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But we haven’t been able to reach him yet, Senora, and you’re still weak,” the nurse said coaxingly. “You must give us a chance to find him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anabella didn’t answer. Her hand gripped the gold damask curtain in her hand, fingers trembling. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" tired. Her legs felt oddly weak, her muscles fatigued, but she missed Lucio so much. It’d been forever since she last saw him. Yet he would come for her. Lucio never broke his word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve been ill, Senora. You must rest. Conserve your strength.” The nurse continued in the same patient voice one would use for a high-strung horse or a difficult child. “At least sit and have your lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not hungry.” Anabella hated how the nurse treated her like a child. Anabella didn’t need someone to tell her to rest, to sleep, to eat. She had a brain. She could think for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that they were giving her many opportunities to make decisions for herself.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like coming to this house. She hadn’t wanted to be here. The hospital had been bad enough with its antiseptic smells like the cool metallic scent of rubbing alcohol, the pungent disinfectant used to mop the shiny floors, the oddly pleasing odorless hand lotion worn by the staff nurses. But then they brought her to this big mausoleum of a place in the middle of vineyards.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The villa was enormous and formal and stuffed with antiques and fine art. It was a place for grand parties and elegant luncheons and business functions. It was another of Dante’s extravagances. He had so many. He was so rich.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unlike her Lucio.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only good thing about the house was its proximity to the mountains. And at least from her bedroom window she could see the mountains. Lucio and the mountains were synonymous in her mind. Lucio had grown up in the mountains and his family lived there still.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her fingers tightened on the silk fabric. “So Dante has called Lucio then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse set the clipboard down and her footsteps sounded on the floor. “I don’t know. The Count doesn’t consult with me.” The nurse’s hand settled lightly on Ana’s shoulder. “Shall we finish getting dressed now? Your brother will be here soon. You don’t want to meet him in your nightgown, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want to see him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse withdrew her hand. “You didn’t see him yesterday, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ana’s stomach knotted. “That’s my choice, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s your brother—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what business is that of yours, anyway?” Anabella turned from the window, her arms folding across her chest and she stared at the nurse in the trim white dress with the neat white hose and shoes. “And why are you even here? I’m fine. I don’t need you. I don’t want the fuss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry. It’s your brother’s decision.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“And you wonder why I don’t want to see him?” ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Anabella asked bitterly, moving to a deep armchair in the corner of her room and burying herself inside the protective arms.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dante, Dante, Dante. It was always about Dante. When Dante said jump, people jumped. But Dante didn’t know everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tears stung her eyes and Anabella bent her head, covered her face with her forearm. She felt almost crazy. Her emotions felt so wild, so chaotic and there was a buzz in her head, like the drone of a bee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not dressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ana stiffened at the sound of the deep male voice. So he’d arrived. She glanced up, her gaze meeting her brother’s as he entered her room. He was wearing a charcoal gray suit, a shirt almost the same shade, and no tie. He looked rich, sophisticated, and successful. “I didn’t know I had to dress for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Count Dante Galván glanced at the nurse and she discreetly slipped from the room. He waited until the door was shut. “What’s wrong, Anabella? You’re so angry with everyone lately.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her hands balled into defiant fists. “I want Lucio.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t want him,” he corrected sternly. “Trust me, Ana, you don’t want—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re wrong!” She slammed her fists on the upholstered arms of the chair. “I do want him. I love him. I miss him—” her voice broke and she shook her head, frustrated, furious, unable to bear Dante’s grim expression. He didn’t understand. He didn’t know what it was like to love someone and yet be denied that person.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You left him, Anabella.” Dante’s voice sounded flat. “It was your choice. You realized you didn’t have anything in common. You realized you needed something else, something different than what he could provide.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("“Stop!” He was making her sick and cold and she longed to take the soft afghan from the foot of the bed and wrap it around her. “You’re telling me lies. You’re trying to con")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("fuse me. But it won’t work this time. I know the truth. Lucio "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loves")]), _vm._v(" me.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s not the point, Ana!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s exactly the point.” Her teeth began to chatter. She rubbed her hands along her upper arms trying to get warm, trying to silence the small, frightened voice inside her. Lucio was coming back, wasn’t he? He wouldn’t leave her here with Dante, would he?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re cold.” Dante moved forward, lifting the crimson blanket from the bed and covering Ana’s shoulders. He tucked the edges of the soft, fuzzy blanket around her before touching her forehead. “You’re icy. You need to be resting, Ana. You’ve worn yourself out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t rest.” Teeth chattering she tipped her head back and looked up at her brother. His face seemed so hard and yet his golden eyes glowed. He might look angry with her but she knew he loved her, and despite all his bullying and strong-arm tactics he wanted what was best for her. “Please Dante, find Lucio. I miss him so much. I can’t eat, can’t sleep. Please bring Lucio back to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("There went his wireless phone again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The small phone clipped to Lucio Cruz’s belt silently vibrated yet again, sending tiny currents through his torso. The phone had rung almost constantly during Lucio’s three hour meeting with the California Wine Advisory Council and even though he was now on the way to his car, he still hadn’t had a moment to check his messages yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio reached for his phone as he headed outside to the parking lot where the black convertible Porsche he’d rented at the San Francisco airport waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But before he could answer the phone, footsteps sounded on the pavement and Lucio looked up to see Niccolo Dominici, president of the California Wine Advisory Council, approach. Niccolo, owner of Napa’s famous Dominici Vineyard, had run the afternoon meeting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("“Come have dinner with us,” Niccolo said, sunglasses ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("on to cut the bright afternoon glare. “Maggie’s just phoned. She’s insisting I bring you home with me, wanted me to tell you that you can’t say no. She’s desperate for adult conversation.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio’s lips tugged. He felt a reluctant smile. Niccolo’s wife was beautiful. Spirited. Like his ex-wife Anabella, but unlike Anabella, Niccolo’s wife loved him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His smile faded. “Thank you for the invitation, but I’ve work to do—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Niccolo made an impatient sound. “You’ve worked all day. You need dinner. Company. Hotels can be lonely places.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Actually being in a hotel was less stressful than being home, Lucio thought bitterly. Home didn’t feel like home, not anymore. In the divorce settlement Anabella had gotten the house, the upper vineyard, the apartment in Buenos Aires. He’d taken a small place, a new place, in downtown Mendoza. It was a nice apartment in an expensive building. His one bedroom apartment was elegant with excellent light and a magnificent view of the Andes, but he’d left it virtually unfurnished, buying only a table, a chair and a bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t need more than that. He didn’t intend to be in Mendoza more than he had to. Anabella lived—entertained—in Mendoza. He couldn’t bear to be in the vicinity. Too much had happened between them. Too much pain. Too much disillusionment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio realized Niccolo was watching him, quietly waiting for an answer. “I’m afraid I wouldn’t be good company tonight,” Lucio answered honestly. “Besides, you have three little ones at home anxious to see you. They’d rather have you to themselves.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Lucio had met the children a week ago when he first arrived in California and they were delightful. Jared, the eldest at seven, was fair and wiry with intense blue eyes. Then there was five-year-old Leo, the middle one, the second son, dark like his father with green gold eyes; and the ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("youngest, three-year-old Adriana, with dark curls and dimples and constantly in mischief.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But being with Niccolo, Maggie and the children hadn’t been easy. Lucio found himself envious of his colleague, of the life the Italian vintner had made for himself in Northern California. Lucio, too, craved children but Anabella couldn’t conceive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Niccolo’s hand suddenly clapped Lucio’s shoulder. “You’re sure you won’t join us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Positive.” Lucio started the engine. He just wanted to escape. Niccolo meant well but Lucio couldn’t handle the contact, and certainly wasn’t up for socializing. It’d taken him a number of years, but he was finally good at growing grapes, crushing fruit and making drinkable dinner wine. He was sticking with his strengths. “Give your wife my best. Tell her we’ll have dinner before I go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio drove fast; taking the narrow winding road from Dominici Vineyard to the highway more quickly than he should—far more quickly than the law allowed—but he’d never followed rules, never believed in rules. Rules, his father used to say were made for the man who couldn’t think for himself. Rules, his cowboy culture implied, were for those who needed a norm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t need a norm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even now, despite his success, he didn’t want to be part of the norm, or the exclusive society of his aristocratic wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio’s gaze swept the tight turn ahead and he shifted down, briefly reducing speed until he cleared the turn. The moment he came out of the turn he accelerated hard, practically flying down the stretch of road cutting through the rolling golden hills. Napa was in the middle of an Indian summer and the warm dry air, and the scent of baked earth, ripe fruit, smelled achingly familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe too familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thankfully this fast, rather reckless, drive was exactly what he needed. Freedom. Space. Speed. Adrenaline.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Racing through the hills reminded him of riding bareback ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("on a young stallion. Danger heightened the senses and Lucio found himself relishing the rush of dry wind in his face, the hot sun burning down on his head, the ease with which the sports car hugged the turns.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moving fast, he could almost forget that he’d lost the one person he’d ever loved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time Lucio made it to his hotel room, his phone was ringing again. He answered, hand on the door, half expecting to hear Anabella’s brittle, angry voice. A small part of him still hoped she’d phone. A small part of him hadn’t accepted reality.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it wasn’t Anabella’s voice on the other end of the line. It was Dr. Dominguez, the family physician in Mendoza.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where have you been?” Static on the line made the doctor’s voice sound unnaturally faint.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio reached for the light switch on the wall. “I’ve been in meetings.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve been calling you, leaving messages—” the connection broke up, and then the doctor’s voice came through again, “danger’s past—” and faded out only to fade in again, “an immediate return.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Danger? Where was the danger?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a terrible connection. Lucio couldn’t make out more than a couple words the doctor was saying. He closed the hotel door and headed across the room to see if he couldn’t get better reception there. “Stephen, I missed most of what you just said. Can you repeat that, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. Dominguez replied but again it was static once more and Lucio drew back the drapes at the window to let in the light. “I can’t understand a word you’re saying.” Lucio fought to hang on to his temper. “Tell me again. What’s wrong? What’s happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anabella.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s happened to Anabella?” Dread seeped through his gut as he pushed open the glass door to the balcony.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he didn’t get an answer. The line went dead.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What the hell? What had happened to Anabella? Lucio swore, gripped his phone and started to punch in Dominguez’s number but his phone rang, interrupting him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In that brief twenty-some seconds of silence his mind had spun a dozen different tragic scenarios.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s wrong with Anabella?” Lucio demanded the moment he answered the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctor didn’t waste time. “We think now it’s encephalitis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Encephalitis,” Lucio repeated, wondering if he’d misheard the doctor. The connection still wasn’t the best. What the hell was encephalitis?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a viral infection. It’s very rare, almost never heard of in Argentina, which is why we had difficulty with diagnosing the illness. Your wife has been pretty sick, but we think she’s out of the woods now—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Out of the woods? How sick was she?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctor hesitated, and then cleared his throat. “Encephalitis can be fatal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How sick was she?” Lucio repeated with quiet menace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctor didn’t reply. Lucio closed his eyes, shook his head, his heart and mind dark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one had told him. No one had called him. And it hit him all over again, how he’d always been the outsider. He might have married Anabella, but her family didn’t accept him. They’d barely tolerated him and once they knew Ana wanted out of the marriage they did everything in their power to expedite the divorce itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No wonder he and Anabella hadn’t lasted. They were up against too much. Up against virtually everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctor cleared his throat again. “As I said, it’s not an easy disease to diagnose. It starts out like the flu and quickly progresses. We had to do a lumbar puncture test. A CT brain scan. An MRI scan—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“Goddamn,” Lucio swore, interrupting. A lumbar puncture test? CT scan? MRI scan? They ran all those tests on Anabella without ever calling him…telling him? “When ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("were you going to tell me that my wife might die? After she’s already in a coma? When it’s time to make the funeral arrangements?”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s out of the coma.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio’s hand felt nerveless. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She’d been in a coma?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I induced the coma.” The doctor’s voice was calm, reasonable, sounding as if inducing comas were child’s play. “But she came out of it fine, and the coma did exactly what we hoped. The inflammation is gone. We eventually expect a full recovery.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You induced a coma.” Lucio felt a wave of emotion. They’d put her in a coma; placed her in a deep sleep she might never have emerged from and no one—not one person—had given him the chance to say goodbye.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How dare they? How dare the doctors and her family exclude him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His emotion was nothing short of rage, and hate and a gnawing helplessness. He didn’t like being helpless. He didn’t accept helpless. Helpless was for those too afraid to act.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t afraid to act.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he wasn’t free to act.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Inducing a coma was the best way to limit the seizures. The seizures could have pushed her over the edge.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio closed his eyes, unable to even bear the vision of Anabella so close to death. She’d been the most important person in his life. He’d loved her more than he’d ever loved anyone and to think he’d almost lost her. Permanently. “But you’ve saved her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.” There was relief in the doctor’s voice. “We have. She’s awake, fairly alert.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So why are you calling?” Lucio couldn’t hide his bitterness, or the depth of his pain. Once an outsider, always an outsider. To Ana’s family he’d always be the gaucho. The peasant. The Indian native. “Am I to send flowers? Pick up the hospital tab? What’s my job now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Help her regain her memory.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio tensed. It took him a moment to process this. “You said she’s recovered.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Recovering,” the doctor corrected. “Her body is stronger, but her mind—” he hesitated, picking his words with care, “—her consciousness is altered, has been altered for quite a while—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus!")]), _vm._v(" Lucio rubbed at his temple, his head pounding. He needed sleep. He needed to feel like himself again. “She’s been seriously ill for three weeks?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Four, actually. Ever since her return from China. But the first week everyone thought it was just the flu. There were headaches, vomiting, the usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And then seizures, altered consciousness, coma and loss of memory.")]), _vm._v(" Lucio grimly clamped his teeth together to keep from saying something he’d regret.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She is better now,” the doctor reassured. “But she’s confused. I think…we all think…she needs you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She needed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio nearly laughed out loud. The good doctor didn’t know what he was saying. Anabella most certainly did not need him. She’d made that perfectly clear over and over in the past year.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio reached up to pull the black leather tie from his hair. His heavy black hair fell to his shoulders and with a weary hand he rubbed his temple and his scalp. He was tired. Physically, mentally, emotionally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t continue like this. Couldn’t continue fighting battles he didn’t care about. The grapes, the economy, the Argentina export business—these did not move him. They were a duty, an obligation, but were they truly his?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Ana. She wasn’t his anymore, either.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not to mince words, but her family hired the divorce attorney. I never thought I’d see them asking me to return.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“I can’t speak for Marquita,” the doctor replied, referring to Anabella’s beautifully preserved mother who had a taste ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("for hard liquor, “but the Count has offered to send his plane.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio almost growled his dislike. “I don’t need the Count to send a plane for me. I have transportation of my own, thank you.” It was impossible to hide his bitterness. He and Dante were not friends. Would never be friends. He couldn’t even bear to be in the same room with Anabella’s brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctor hesitated. “What shall I tell the Count?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That I’m packing my things.” Lucio drew a deep breath, forcing himself to suppress his anger towards the Galváns. His marriage might be over, but it didn’t change his feelings. Married or divorced, in his mind, Anabella would always be his wife. To death do us part, and he’d meant it. “I’ll be home tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But on the plane that night, stretched out in the leather lounge chair in the first class cabin, Lucio’s thoughts were tangled. His emotions even more jangled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to picture Anabella ill. He couldn’t. His Ana was tough. Physically, mentally, emotionally. She was as spirited and independent as they came. Nothing touched her. Nothing fazed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ironically, it was her strength that had allowed the divorce to happen in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d been the one who pushed. He’d fought the divorce, fought her, for months, refusing to let go. But his refusal only pushed her further away. Her anger gave way to tears, and then the tears gave way to silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They stopped speaking. Stopped being in the same room at the same time. Stopped all communication.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He remembered asking her what she wanted for her birthday and she faced him across the long dinner table, he at one end, she at the other, and she very politely said, “A divorce, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And in that calm voice, and that quiet moment, he agreed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Later when they sat down to sign the papers, he’d hesitated. But tears welled up in her eyes, and she stretched a ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("hand out across the table, entreating, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Let me go, Lucio. We’re both so miserable. Please just let me go.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He caught her hands in his and saw the tears in her beautiful eyes, the quiver of her full passionate mouth and felt hell close round him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silently he signed his name, dated the document and walked away without another word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he hadn’t really walked away, he thought now, leaning his head back against the wide leather seat. He’d been ignoring the truth, denying the truth, unable to handle the fact that Ana could so easily dispose of him, of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eyes burning, Lucio swallowed the rush of hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You were wrong, Anabella,")]), _vm._v(" he thought, eyes closed, chest livid with pain. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I might have been miserable at times, but I never wanted out. Your love might have died. But I will always love you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The commercial jet landed in Chile early the next morning, where Lucio took a connecting flight, arriving in Mendoza just after ten. A car was waiting for him, and the driver—one of Lucio’s own—didn’t offer any information and Lucio didn’t ask.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mendoza had only been home for four years. Lucio had bought the vineyard, villa and business with one cashier’s check. He’d known nothing about the winery business at the time. He just knew it was respectable and respectable was what Ana’s family demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But now as the chauffeur wove on and off the highway towards the villa nestled in the foothills, Lucio couldn’t help reflecting that Ana had loved the gaucho, not the vintner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The black town car drove through ornate iron gates tipped in gold, and turned down a long private lane leading to an elegant two-story villa, the smooth plaster walls a wash of soft apricot paint. It might be wine country Argentina, but the house was all Tuscany. The original owners had been Italian. The wood beams, hardwood floor, roof tiles all imported from Italy.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the morning sun casting a warm rosy glow across the front of the one-hundred-year-old villa with the tall cypress trees and the plaster arch flanking the front door, the house looked magical.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio felt a pang of loss. This is the place he’d brought Ana as his new bride. This is the place he’d thought they’d finally make their home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nothing ever worked out as one hoped, did it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shall I bring your bags in, Senor?” The chauffeur’s respectful voice interrupted Lucio’s painful thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lucio shook off his dark mood, stepped from the car, and adjusted the collar on his black leather traveling coat. He’d do what he’d have to do. “No, Renaldo. I’ll be staying at my apartment downtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly there was a shout from upstairs. He heard his name called. Once, twice, and Lucio turned to look up at the second floor of the villa. The windows were open to welcome the freshness of the morning. He searched the windows for a glimpse of Anabella but saw nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seconds later the front door burst open and suddenly she was there, on the doorstep, breathless from the dash down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lucio,” Anabella cried, green eyes bright. “You’re home!”")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c14c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426877339_ch01.vue
// module id = 72
// module chunks = 0